import { render, staticRenderFns } from "./Activated.vue?vue&type=template&id=21838256&scoped=true&"
import script from "./Activated.vue?vue&type=script&lang=js&"
export * from "./Activated.vue?vue&type=script&lang=js&"
import style0 from "./Activated.vue?vue&type=style&index=0&id=21838256&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21838256",
  null
  
)

export default component.exports